import { bool, func } from 'prop-types';
import React, { Component } from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import SingleSelect from '../../../generic/SingleSelect';
import { opportunityShape } from '../../../prop-types';
import { salesUnits, salesUnitSalesTeams } from '../../constants';

export default class OpportunitySalesUnit extends Component {
  handleSalesUnitChange = e => {
    const { onChange } = this.props;
    onChange(e);

    onChange({
      target: {
        name: 'salesTeam',
        value: '',
      },
    });
  };

  render() {
    const { opportunity, onChange, readOnly } = this.props;
    const { salesUnit, salesTeam } = opportunity;

    return (
      <>
        <FormGroup row>
          <Label sm={4} for="op-salesUnit" className="required">
            Sales Unit
          </Label>
          <Col sm={8}>
            <SingleSelect
              options={salesUnits}
              id="op-salesUnit"
              name="salesUnit"
              value={salesUnit}
              onChange={this.handleSalesUnitChange}
              readOnly={readOnly}
            />
          </Col>
        </FormGroup>
        {salesUnitSalesTeams[salesUnit]?.length > 0 && (
          <FormGroup row>
            <Label sm={4} for="op-salesTeam">
              Sales Team
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={salesUnitSalesTeams[salesUnit]}
                id="op-salesTeam"
                name="salesTeam"
                value={salesTeam}
                onChange={onChange}
                readOnly={readOnly}
              />
            </Col>
          </FormGroup>
        )}
      </>
    );
  }
}

OpportunitySalesUnit.propTypes = {
  opportunity: opportunityShape.isRequired,
  onChange: func,
  readOnly: bool,
};

OpportunitySalesUnit.defaultProps = {
  onChange: () => {},
  readOnly: undefined,
};
